var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultipleSelect',{attrs:{"data-private":"","data-testid":"tags-selector","itemValue":"id","disabled":_vm.disabled,"label":_vm.resolvedLabel,"loading":_vm.loading,"options":_vm.tagsOptions,"required":_vm.required,"showSelectAll":false,"value":_vm.value},on:{"change":_vm.onChangeTags}})
}
var staticRenderFns = []

export { render, staticRenderFns }